import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Send, Phone } from "lucide-react";

export const WhatsAppPreviewCard = ({ item, busy, onSend }) => (
  <Card className="p-5 border-slate-200 flex flex-col gap-3" data-testid={`whatsapp-preview-${item.employee_id}`}>
    <div className="flex items-start justify-between gap-3">
      <div>
        <div className="font-semibold text-slate-900">{item.employee_name}</div>
        <div className="text-xs text-slate-500 flex items-center gap-1 mt-0.5">
          <Phone className="h-3 w-3" />
          {item.to ? <span className="font-mono">+{item.to}</span> : <span className="text-red-500">Telefon yok</span>}
          <span className="mx-1">·</span>{item.job_count} iş
        </div>
      </div>
      <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 shrink-0" disabled={busy || !item.to} onClick={onSend} data-testid={`whatsapp-send-${item.employee_id}`}>
        <Send className="h-4 w-4 mr-1" /> Gönder
      </Button>
    </div>
    <pre className="whitespace-pre-wrap text-sm text-slate-700 bg-emerald-50/60 border border-emerald-100 rounded-xl p-3 font-sans" data-testid={`whatsapp-message-${item.employee_id}`}>{item.message}</pre>
  </Card>
);
